import { apiClient } from "./client";
import type { OrderStatusFilter, PeriodFilter } from "../../pages/reports/helpers";
import type { ReportsChannelFilter } from "../../pages/reports/ReportsAnalyticsFilters";
import type { SalesAnalyticsTab } from "../../pages/reports/salesAnalyticsTypes";

export interface SavedReportFilters {
    tab: SalesAnalyticsTab;
    period: PeriodFilter;
    dateFrom?: string | null;
    dateTo?: string | null;
    channel: ReportsChannelFilter;
    region: string;
    store: string;
    client: string;
    product: string;
    status: OrderStatusFilter;
}

export interface SavedReport {
    id: number;
    name: string;
    tab: SalesAnalyticsTab;
    filters: SavedReportFilters;
    scheduleEnabled: boolean;
    scheduleFrequency: "weekly" | "monthly" | null;
    scheduleEmail: string | null;
    lastSentAt: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface SavedReportsListResponse {
    items: SavedReport[];
    storageReady: boolean;
}

export interface SaveReportPayload {
    name: string;
    filters: SavedReportFilters;
    scheduleEnabled?: boolean;
    scheduleFrequency?: "weekly" | "monthly" | null;
    scheduleEmail?: string | null;
}

export async function fetchSavedReports() {
    const response = await apiClient.get<SavedReportsListResponse>("/reports/saved");

    return response.data;
}

export async function createSavedReport(payload: SaveReportPayload) {
    const response = await apiClient.post<{ item: SavedReport }>("/reports/saved", payload);

    return response.data.item;
}

export async function updateSavedReport(id: number, payload: SaveReportPayload) {
    const response = await apiClient.put<{ item: SavedReport }>(`/reports/saved/${id}`, payload);

    return response.data.item;
}

export async function deleteSavedReport(id: number) {
    await apiClient.delete(`/reports/saved/${id}`);
}
